import * as React from "react";
import type { SVGProps } from "react";
const SvgPlusMedium = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M1 8h14M8 15V1"
    />
  </svg>
);
export default SvgPlusMedium;
